import { AllInclusiveBoxOutlineIcon } from './AllInclusiveBoxOutlineIcon';

/**
 * author: Colton Wiscombe
 * id C3D587B3-D1F0-4C6F-9E4F-5FEE39AFFE33
 * name all-inclusive-box-outline
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/all-inclusive-box-outline.svg
 * tags
 */
export const InfinityBoxOutlineIcon = AllInclusiveBoxOutlineIcon;
export default InfinityBoxOutlineIcon